<template>
  <div class="chat-conversations-tabs">
    <div
      v-for="tab in tabs"
      :key="tab.value"
      class="chat-conversations-tab"
      :class="{ active: localValue === tab.value }"
      @click="changeTab(tab.value)"
    >
      {{ tab.value }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatConversationsTabs',
  props: {
    value: {
      type: String,
      required: false,
      default: 'aberto'
    },
    tabs: {
      type: Array,
      required: true,
      default: () => []
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:value'],
  model: {
    prop: 'value',
    event: 'update:value'
  },
  data () {
    return {
      activeTab: ''
    }
  },
  computed: {
    localValue: {
      get () {
        return this.activeTab
      },
      set (value) {
        this.activeTab = value
        this.$emit('update:value', value)
      }
    }
  },
  mounted () {
    this.activeTab = this.value
  },
  methods: {
    changeTab (tab) {
      if (this.disabled) return

      this.localValue = tab
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/conversations/ConversationsTabs.vue